
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Knowledge = lazy(() => import('../pages/knowledge/page'));
const Practice = lazy(() => import('../pages/practice/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Emergency = lazy(() => import('../pages/emergency/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/knowledge',
    element: <Knowledge />,
  },
  {
    path: '/practice',
    element: <Practice />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/emergency',
    element: <Emergency />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
